{
  "id": "campaign-156",
  "name": "Breezy Lea",
  "seed": "campaign:156",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "..x..................h",
    ".....k..#.............",
    ".x.......#......*..,h.",
    "...............***.,,.",
    "................*.....",
    ".....Y...............T",
    ".h....................",
    "..........#...........",
    "...............Y......",
    ".T....#...............",
    "......................",
    "....................x.",
    "#............~.,.,....",
    "................,.....",
    "..x..h................",
    "......................",
    "......T.h...........k.",
    "...............T......",
    "........x.............",
    "............h......h..",
    "........T......h.....S"
  ],
  "critters": [
    {
      "kind": "stag",
      "x": 10,
      "y": 16
    },
    {
      "kind": "deer",
      "x": 12,
      "y": 11
    },
    {
      "kind": "deer",
      "x": 12,
      "y": 10
    },
    {
      "kind": "deer",
      "x": 10,
      "y": 0
    },
    {
      "kind": "deer",
      "x": 11,
      "y": 0
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 18,
      "y": 12
    },
    {
      "kind": "gas",
      "x": 7,
      "y": 13
    },
    {
      "kind": "gas",
      "x": 11,
      "y": 7
    },
    {
      "kind": "gas",
      "x": 12,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 11
    },
    {
      "kind": "rare",
      "x": 0,
      "y": 0
    }
  ],
  "hills": [
    {
      "x": 3,
      "y": 9,
      "w": 7,
      "h": 7
    },
    {
      "x": 17,
      "y": 12,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 156,
  "biome": "meadow",
  "par": {
    "reel": 15968,
    "push": 13840,
    "selfPropelled": 12768,
    "tractor": 10560,
    "zeroTurn": 8989,
    "fairway": 5115
  },
  "goldTime": {
    "reel": 15968,
    "push": 13840,
    "selfPropelled": 12768,
    "tractor": 10560,
    "zeroTurn": 8989,
    "fairway": 5115
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 1
    },
    "gold": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 1
    }
  }
}
